var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('McButton',{attrs:{"variant":`${_vm.favotireRetport ? 'warning' : 'secondary-warning'}`,"text":_vm.$t('global.object.favorite'),"icon":`icon-${_vm.favotireRetport ? 'fill' : 'outline'}_star`},on:{"click":_vm.onFavorite}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }